module.exports = __webpack_public_path__ + "908e9372a03eaf0d5c504beeba17ea26.svg";